<template>
  <div class="customPage">
    <h2 class="customPageTitle">대기중</h2>
    <v-container class="customPageContent text-center">
      <p>챌린저의 참가를 기다리고 있습니다.</p>
      <p>카카오톡으로 초대하거나, 초대 코드를 직접 전달해주세요!</p>
      <p>초대코드 : {{code}}</p>
      <!-- <v-btn class="customButton" @click="invite" :loading="link ? false : true">카카오톡으로 초대</v-btn> -->
      <v-btn class="customButton" @click="invite" :loading="link ? false : true">카카오톡으로 초대</v-btn>
    </v-container>
  </div>
</template>
<script>
// 챌린저 참가 대기
export default {
  name: "Pending",
  computed: {
    challengeId() {
      return this.$store.getters.challengeId;
    },
  },
  data() {
    return {
      matched: false,
      link: undefined,
      code: undefined
    };
  },
  methods: {
    getLink() {
      // if (this.link === undefined) {
      //   this.$axios
      //     .post("/challenges/" + this.$store.getters.challengeId + "/invite")
      //     .then((response) => {
      //       this.link = response.data.link;
      //       this.code = response.data.code;
      //     });
      // }
      window.setTimeout(()=>{
        this.link = true;
        this.code = '1111111111111111';
      }, 3000);
    },
    invite() {
      // window.Kakao.Link.sendDefault({
      //   objectType: "feed",
      //   content: {
      //     title: "금연하자! 위던으로!",
      //     description:
      //       this.$store.getters.nickname + "님이 위던에 초대하였습니다.",
      //     imageUrl:
      //       "https://wedone.s3.ap-northeast-2.amazonaws.com/wedone_kakao.png",
      //     link: {
      //       webUrl: this.link,
      //       mobileWebUrl: this.link,
      //     },
      //   },
      //   buttons: [
      //     {
      //       title: "함께하기",
      //       link: {
      //         mobileWebUrl: this.link,
      //         webUrl: this.link,
      //       },
      //     },
      //   ],
      // });
      this.matched = true;
    },
    waiting() {
      window.localStorage.setItem('pending', 'pending');
      var vm = this;
      (function fiveSeconds(n) {
        if (vm.matched === false) {
          setTimeout(function () {
            fiveSeconds(n);
          }, 5000);
        } else {
          return 0;
        }
        vm.$axios
          .get("/challenges/" + vm.challengeId + "/created")
          .then((response) => {
            if (response.data === true) {
              vm.matched = true;
              window.localStorage.removeItem('pending');
              return 0;
            }
          });
      })(0);
    },
  },
  watch: {
    matched(v) {
      if (v === true) {
        this.$router.push("/home");
      }
    },
    link() {
      this.invite();
    },
  },
  async mounted() {
    await this.getLink();
    // this.waiting();
  },
};
</script>
